import { View, SxProp } from 'dripsy';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { UniButton } from '../buttons';
import { ButtonVariant } from '../buttons/useButton.hook';

export interface PaginationProps {
  current: number;
  pageSize: number;
}

export interface PaginationParams {
  currentPage: number;
  totalPages: number;
  onNextPage: () => void;
  onPrevPage: () => void;
  sx?: SxProp;
}

export const Pagination: React.FC<PaginationParams> = ({ currentPage, totalPages, onNextPage, onPrevPage, sx }) => {
  const { t } = useTranslation('earn');

  return (
    <View sx={{ ...styles.container, ...sx }}>
      <UniButton
        label={t('earn-invest::glossary.previous')}
        prefixIcon="arrowLeft"
        variant={ButtonVariant.outline1}
        onPress={onPrevPage}
        sx={styles.button}
        disabled={currentPage === 1}
      />
      <UniButton
        label={t('earn-invest::glossary.next')}
        suffixIcon="arrowRight"
        variant={ButtonVariant.outline1}
        onPress={onNextPage}
        sx={styles.button}
        disabled={currentPage === totalPages}
      />
    </View>
  );
};

enum StyleName {
  container = 'container',
  button = 'button'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '$3'
  },
  button: {
    paddingX: '$3',
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '$borderButton'
  }
};
